var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckBlue = function SvgCheckBlue(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8118 0.710938H14.4466C14.2552 0.710938 14.0736 0.798828 13.9564 0.949219L5.90364 11.1504L2.04231 6.25781C1.9839 6.18365 1.90944 6.12368 1.82454 6.08241C1.73963 6.04114 1.64648 6.01965 1.55207 6.01953H0.186839C0.05598 6.01953 -0.0162857 6.16992 0.0637925 6.27148L5.4134 13.0488C5.6634 13.3652 6.14387 13.3652 6.39582 13.0488L15.9349 0.960938C16.015 0.861328 15.9427 0.710938 15.8118 0.710938Z",
    fill: "#1890FF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "check-blue.ac0688af6498c8fd90ade0abb50610a0.svg";